export enum RecipientEnum {
  USER = 'USER',
  EXTERNAL_USER = 'EXTERNAL_USER',
  CREATOR = 'CREATOR',
  TRANSFER_EDITOR = 'TRANSFER_EDITOR',
  OTHER_TRANSFER_EDITORS = 'OTHER_TRANSFER_EDITORS',
  ORGANISATION = 'ORGANISATION',
  DEPARTMENT = 'DEPARTMENT',
  CUSTOMER = 'CUSTOMER',
  INTERNAL_TRANSFER_CUSTOMER = 'INTERNAL_TRANSFER_CUSTOMER',
  EXTERNAL_TRANSFER_CUSTOMER = 'EXTERNAL_TRANSFER_CUSTOMER',
  SHARED_POOL_OWNER = 'SHARED_POOL_OWNER',
  INTEMP = 'INTEMP',
}
